const RoleTypes = {
  ROLE_ADMIN:'admin',
  ROLE_BASIC_ACCESS:'basic access',
  ROLE_BRANCH_MANAGER: 'non-producing branch manager',
  ROLE_CSA: 'csa',
  ROLE_FINANCIAL_ADVISOR: 'financial advisor',
  ROLE_OPERATIONS: 'operations',
  ROLE_PRODUCING_BRANCH_MANAGER: 'producing branch manager',
  ROLE_PRODUCTION_SUPPORT: 'production support – asg',
  ROLE_REGISTERED_CSA: 'registered csa'
};

export default RoleTypes;


// WEBPACK FOOTER //
// ./src/constants/RoleTypes.js